import { GALLERY_TABS, type GalleryStatus } from '@/features/gallery/types/gallery';

type GalleryStatusTabsProps = {
  status: GalleryStatus;
  counts: Record<string, number | undefined>;
  onSelect: (status: GalleryStatus) => void;
};

export function GalleryStatusTabs({ status, counts, onSelect }: GalleryStatusTabsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {GALLERY_TABS.map((tab) => {
        const active = status === tab.key;
        const count = Number(counts[tab.countKey] || 0);
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onSelect(tab.key)}
            className={`relative rounded-xl border px-4 py-2 text-sm font-semibold transition ${
              active
                ? 'border-[var(--dash-brand)] bg-[var(--dash-brand)] text-white'
                : 'border-[var(--dash-line)] bg-white text-[var(--dash-muted)] hover:text-[var(--dash-ink)]'
            }`}
          >
            {tab.label}
            {count > 0 ? (
              <span
                className={`absolute -top-2 -right-2 flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[10px] font-bold ${
                  active ? 'bg-red-500 text-white' : 'bg-[var(--dash-brand)] text-white'
                }`}
              >
                {count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
